import React from 'react';
import './style.scss';
import { Popup } from 'react-leaflet';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { isMobile } from "react-device-detect";

const useStyles = makeStyles({
    root: {
        //display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor: '#fefefe',
        maxWidth: isMobile ? 150 : 200,
    },
    media: {
        objectFit: 'cover',
        width: '100%',
        maxHeight: 150,
        //maxWidth: 215
    },
    featuredWImageCardContent: {
        padding: 5
    },
    popupSubInfo: {
        borderRadius: 5,
        height: "20px",
        width: "100%",
        lineHeight: "20px",
        padding: "2px",
        marginLeft: "-5px",
        marginBottom: "0px"
    },
    featuredWImageTitle: {
        fontSize: "14px",
        lineHeight: "14px",
        textAlign: "left",
        color: "#000",
        margin: "0px",
        marginBottom: "5px",
        fontWeight: "500"
    }
});
const popupGenerator = (props, classes) => {
    if (props.popupType === "featurePopupWImage") {
        return FeaturePopupWImage(props, classes)
    } else if (props.popupType === "basic") {
        return <Popup>{props.title}</Popup>
    } else if (props.popupType === "featurePopup") {
        return FeaturePopup(props)
    }
}
export default function PopupComponent(props) {
    const classes = useStyles();
    return (
        <div className="popup_component">
            {popupGenerator(props, classes)}
        </div>
    );
}

const FeaturePopupWImage = (props, classes) => {
    const { links, title, popupDescription, popupSubInfo, imgUrl } = props;
    return (
        <Popup className="custom_popup">
            <Card className={classes.root} elevation={0}>
                <div>
                    <span className={classes.featuredWImageTitle}>
                        {title}
                    </span>
                </div>
                <CardActionArea >
                    <CardMedia
                        className={classes.media}
                        component="img"
                        alt={title}
                        image={imgUrl}
                        title={title}
                    />
                    <CardContent className={classes.featuredWImageCardContent}>
                        <div className={classes.popupSubInfo}>
                            <span style={{ color: "#A9A9A9", textAlign: "left" }}>{popupSubInfo}</span>
                        </div>
                        <Typography variant="body2" color="textSecondary" component="p">
                            {popupDescription}
                        </Typography>
                    </CardContent>
                </CardActionArea>

                {/* <CardActions>
                    <Button onClick={() => alert("share")} size="small" color="primary">
                        Share
                    </Button>
                    <Button size="small" color="primary">
                        Learn More
                    </Button>
                </CardActions> */}
            </Card>

        </Popup>
    );
}

const FeaturePopup = (props) => {
    const { popupTitle, popupSubtitle, popupData } = props;
    const useStyles = makeStyles({
        root: {
            minWidth: 275,
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
    });
    const classes = useStyles();
    return (
        <Popup className="feature_popup">
            <h2 className="feature_popup_title">{popupTitle}</h2>
            <Divider />
            <h4 className="feature_popup_category">{popupSubtitle}</h4>
            <ul className="feature_popup_ul">
                {
                    Object.entries(popupData).map(([key, value]) => {
                        return (<li className="feature_popup_li"><b>{`${key}: `}</b>{value}</li>)
                    })
                }
                <Divider />
            </ul>
        </Popup >
    );
}